/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const PayByCard = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 16">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M22.1 16H1.9C0.84 16 0 15.17 0 14.15V7.07685H24V11.6924H19.3346C18.9664 11.6924 18.668 11.899 18.668 12.1539V13.077C18.668 13.3319 18.9664 13.5385 19.3346 13.5385H24V14.15C24 15.17 23.15 16 22.1 16ZM0 1.85V4.30762H24V1.85C24 0.83 23.15 0 22.1 0H1.9C0.85 0 0 0.83 0 1.85Z" />
    </BaseSvgIcon>
  )
}

export default PayByCard
